import { GridColTypeDef, GridValueFormatterParams } from "@mui/x-data-grid-pro";

export const yearColDef: GridColTypeDef = {
  type: "number",
  headerName: "Year",
  width: 100,
  valueFormatter: ({ value }: GridValueFormatterParams<number>) => value?.toString(),
};
